import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/language-symbols.jpg")